import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ProjectCreationFormWrapper } from 'src/Components/Forms/Project/ProjectCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateProjectDrawer = () => {
  const { t } = useTranslation();

  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t('projects.create.title', 'Nouveau projet / idée')}
      to={`/asset/${assetId}/project-and-works`}
    >
      {({ onClose }) => <ProjectCreationFormWrapper onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default CreateProjectDrawer;
